// src/App.js
import React, { useState, useEffect } from 'react'; 
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from './components/Header';
import AboutUs from './components/AboutUs';
import Locations from './components/Locations';
import Quote from './components/Quote';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import LocationDetails from './components/LocationDetails';
// import MyAccount from './components/MyAccount'; 
// import LoginForm from './components/LoginForm'; 

function App() {
  // **Added authentication state**
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const [user, setUser] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  // **Function to handle login**
  // const handleLogin = (userData) => {
  //   setIsAuthenticated(true);
  //   setUser(userData);
  // };

  // **Function to handle logout**
  // const handleLogout = () => {
  //   setIsAuthenticated(false);
  //   setUser(null);
  // };

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-background text-text font-sans">
        {/* **Pass authentication props to Header** */}
        <Header
          // isAuthenticated={isAuthenticated}
          // user={user}
          // handleLogin={handleLogin}
          // handleLogout={handleLogout}
        />
        <main className="flex-grow pt-16">
          <Routes>
            {/* Home Page Route */}
            <Route
              path="/"
              element={
                <div className="container mx-auto px-4 py-12">
                  <AboutUs />

                  {/* Flex container for Quote and Locations */}
                  <div className="flex flex-col md:flex-row md:space-x-8 md:items-center">
                    {/* Quote Component */}
                    <div className="md:w-1/2 mb-8 md:mb-0">
                      <Quote />
                    </div>
                    {/* Locations Component */}
                    <div className="md:w-1/2">
                      <Locations />
                    </div>
                  </div>

                  <ContactUs />
                </div>
              }
            />
            {/* Location Details Route */}
            <Route path="/locations/Paradise Valley - Phoenix" element={<LocationDetails />} />

            {/* **Add the /account route** */}
            {/* <Route
              path="/account"
              element={
                isAuthenticated ? (
                  <MyAccount user={user} />
                ) : (
                  <LoginForm onLogin={handleLogin} />
                )
              }
            /> */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
